<template>
  <a
    href="#"
    class="navigation-icon"
    v-on:click.prevent
    v-bind="{ name, hasBadge, badgeLabel }"
    @click="toggle(name, title)"
  >
    <div v-if="hasBadge" class="has-badge">
      <slot />
      <SfBadge v-if="badgeLabel > 0" class="has-badge--number">
        {{ badgeLabel }}
      </SfBadge>
    </div>
    <div v-else>
      <slot />
    </div>
  </a>
</template>
<script>
import {
  SfBadge,
} from '@storefront-ui/vue';

import sidebar from '../mixins/sidebar';

export default {
  name: 'SidebarLink',
  mixins: [sidebar],
  components: {
    SfBadge,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    hasBadge: {
      type: Boolean,
      default: false,
    },
    badgeLabel: {
      type: [String, Number],
      default: '0',
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggle(type, title) {
      this.toggleSidebar({
        type: this.sidebar.type !== type ? type : '',
        visible: this.sidebar.type !== type,
        title: this.sidebar.type !== type ? title : '',
      });
    },
  },
};

</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
.navigation-icon {
  padding: var(--spacer-xs);
  color: var(--c-link);
  &:hover {
    color: var(--c-link-hover)
  }
}
.has-badge {
  position: relative;
  &--number {
    position: absolute;
    bottom: -0.5rem;
    right: -1rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: var(
      --circle-icon-badge-width,
      var(--circle-icon-badge-size, 1.125rem)
    );
    min-height: var(
      --circle-icon-badge-height,
      var(--circle-icon-badge-size, 1.125rem)
    );
    padding: 2px;
    border-radius: var(--circle-icon-badge-border-radius, 0.625rem);
    background: var(--circle-icon-badge-background, var(--c-danger));
  }
}
</style>
